/**
 * **THE LANGUAGES THE APP SPEAKS** (Spanish for 3.0.11, Evan 2026-09-28). Each grown-up has their own, starting in the
 * phone's language; a child's is set by a grown-up in that child's settings. Which languages a family may pick is the
 * public config's `languages` — English only until Evan opens Spanish (the API's `SPANISH`).
 */
export const LANGUAGES = ['en', 'es'] as const;
export type Language = (typeof LANGUAGES)[number];

/** A stored language, or English when none was ever set. */
export const languageOr = (language: Language | undefined | null): Language => language ?? 'en';

export const isLanguage = (x: unknown): x is Language => typeof x === 'string' && (LANGUAGES as readonly string[]).includes(x);
